import util from '../util'

let base = window.$servicePath


export default {

  updateUserPassword(...args) {
    return util.ajax(`${base}/free/sys/updateUserPassword`,...args)
  },
  sendEmail(...args){
    return util.ajax(`${base}/free/sys/sendEmail`,...args)   
  },
  sendPhone(...args){
    return util.ajax(`${base}/free/sys/sendPhone`,...args)   
  },
  getUserByLoginId(...args){
    return util.ajax(`${base}/free/sys/getUserByLoginId`,...args)   
  },
  register(...args){
     return util.ajax(`${base}/api/sys/register`, ...args)
  }
 

}



// WEBPACK FOOTER //
// ./src/common/api/free.js